export const OtelOp = {
    RENDER_PRIMARY: {
        name: 'chart_lib_primary_render',
        description: 'Renders the chart visualization using Highcharts',
    },
    RENDER_UPDATE: {
        name: 'chart_lib_render_update',
        description: 'Re-renders chart after a configuration edit (data labels, axis rename, etc.)',
    },
    RENDER_SECONDARY: {
        name: 'chart_lib_secondary_render',
        description: 'Applies data labels and axis bindings after primary render',
    },
    RENDER_REFLOW: {
        name: 'chart_lib_reflow',
        description: 'Reflows chart layout to fit container dimensions',
    },
    RENDER_QUEUE_PRIMARY: {
        name: 'chart_lib_primary_render_queue',
        description: 'Queue slot measuring wait time before primary render',
    },
    RENDER_QUEUE_SECONDARY: {
        name: 'chart_lib_secondary_render_queue',
        description: 'Queue slot measuring wait time before secondary render',
    },
    NETWORK_DATA_UPDATE: {
        name: 'chart_lib_data_update',
        description: 'Full update cycle from data receipt through render',
    },
    DATA_PROCESS: {
        name: 'chart_lib_process_data',
        description: 'Transforms raw query data into chart data model on initial load',
    },
    DATA_REINITIALIZE: {
        name: 'chart_lib_reinitialize_data',
        description: 'Re-processes data model when viz or parameters change',
    },
    KPI_COMPARISON_FETCH: {
        name: 'kpi_chart_comparison_fetch',
        description: 'Time from KPI first-call complete to comparison data available',
    },
    CORTEX_ANOMALY_DETECT: {
        name: 'kpi_chart_anomaly_detect',
        description: 'Time from anomaly detection start to cache hit, error, or timeout',
    },
};
//# sourceMappingURL=otel-operations.js.map